"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = require("react");

var _lab = require("@mui/lab");

var _material = require("@mui/material");

var _Typography = require("../Typography");

var _SelectField = require("../SelectField");

var _MenuItem = require("../MenuItem");

var _PaginationItem = _interopRequireDefault(require("./PaginationItem"));

var _utilities = require("../../utilities");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["showing", "showPerPage", "navigation"];
var StyledBox = (0, _material.styled)(_material.Box)(function (_ref) {
  var _ref2;

  var theme = _ref.theme;
  return _ref2 = {}, (0, _defineProperty2.default)(_ref2, "& .".concat(_utilities.classes.components.MuiInput.root), {
    marginLeft: theme.spacing(1),
    width: "fit-content"
  }), (0, _defineProperty2.default)(_ref2, "alignItems", "center"), (0, _defineProperty2.default)(_ref2, "display", "flex"), (0, _defineProperty2.default)(_ref2, "justifyContent", "space-between"), _ref2;
});
var StyledUl = (0, _material.styled)("ul")(function (_ref3) {
  var theme = _ref3.theme;
  return {
    alignItems: "center",
    display: "flex",
    flexWrap: "wrap",
    listStyle: "none",
    margin: theme.spacing(0),
    padding: theme.spacing(0)
  };
});

var PaginationControls = function PaginationControls(_ref4) {
  var getAriaLabel = _ref4.getAriaLabel,
      labels = _ref4.labels,
      _ref4$showFirstButton = _ref4.showFirstButton,
      showFirstButton = _ref4$showFirstButton === void 0 ? true : _ref4$showFirstButton,
      _ref4$showLastButton = _ref4.showLastButton,
      showLastButton = _ref4$showLastButton === void 0 ? true : _ref4$showLastButton,
      totalItems = _ref4.totalItems,
      page = _ref4.page,
      size = _ref4.size,
      onPageChange = _ref4.onPageChange;

  var _useState = (0, _react.useState)(page !== null && page !== void 0 ? page : 1),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      currentPage = _useState2[0],
      setCurrentPage = _useState2[1];

  var _useState3 = (0, _react.useState)(size !== null && size !== void 0 ? size : 25),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      pageSize = _useState4[0],
      setPageSize = _useState4[1];

  var showing = labels.showing,
      showPerPage = labels.showPerPage,
      navigation = labels.navigation,
      itemLabels = (0, _objectWithoutProperties2.default)(labels, _excluded);
  var isControlledPage = !!page;
  var isControlledSize = !!size;

  var _onChange = (0, _react.useCallback)(function (e, page, size) {
    if (!isControlledPage) setCurrentPage(page);
    if (!isControlledSize) setPageSize(size);
    onPageChange(e, page, size);
  }, [onPageChange, isControlledPage, isControlledSize]);

  var _usePagination = (0, _lab.usePagination)({
    count: totalItems < (size !== null && size !== void 0 ? size : pageSize) ? 1 : Math.ceil(totalItems / (size !== null && size !== void 0 ? size : pageSize)),
    onChange: function onChange(e, page) {
      return _onChange(e, page, size !== null && size !== void 0 ? size : pageSize);
    },
    page: page !== null && page !== void 0 ? page : currentPage,
    showFirstButton: showFirstButton,
    showLastButton: showLastButton
  }),
      items = _usePagination.items;

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledBox, {
    sx: {
      width: "100%"
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledBox, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.Typography, {
        color: "inherit",
        variant: "body2",
        children: showing
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledBox, {
        sx: {
          marginLeft: function marginLeft(theme) {
            return theme.spacing(3);
          }
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.Typography, {
          color: "inherit",
          variant: "body2",
          children: showPerPage
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_SelectField.SelectField, {
          dataTestId: "page-size",
          name: "pageSize",
          onChange: function onChange(e) {
            return (// Reset the back to page 1 every time the page size changes.
              _onChange(e, 1, e.target.value)
            );
          },
          value: size !== null && size !== void 0 ? size : pageSize,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem.MenuItem, {
            label: "10",
            value: 10
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem.MenuItem, {
            label: "25",
            value: 25
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem.MenuItem, {
            label: "50",
            value: 50
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem.MenuItem, {
            label: "100",
            value: 100
          })]
        })]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Box, {
      "aria-label": navigation,
      component: "nav",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledUl, {
        children: items.map(function (item, index) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_PaginationItem.default, {
            getAriaLabel: getAriaLabel,
            item: item,
            labels: itemLabels
          }, index);
        })
      })
    })]
  });
};

var _default = PaginationControls;
exports.default = _default;